import citizenComplaintCategoriesAPI from '../../api/captain/citizenComplaintCategories';

const state = {
  records: [],
  uiFlags: {
    fetching: false,
    creating: false,
    updating: false,
    deleting: false,
  },
};

const getters = {
  getCategories: s => s.records.sort((a, b) => a.position - b.position),
  getEnabledCategories: s =>
    s.records.filter(c => c.enabled).sort((a, b) => a.position - b.position),
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_CATEGORIES(s, categories) {
    s.records = categories;
  },
  ADD_CATEGORY(s, category) {
    s.records.push(category);
  },
  UPDATE_CATEGORY(s, updated) {
    const idx = s.records.findIndex(c => c.id === updated.id);
    if (idx !== -1) s.records.splice(idx, 1, updated);
  },
  DELETE_CATEGORY(s, id) {
    s.records = s.records.filter(c => c.id !== id);
  },
  SET_UI_FLAG(s, data) {
    s.uiFlags = { ...s.uiFlags, ...data };
  },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { fetching: true });
    try {
      const { data } = await citizenComplaintCategoriesAPI.getAll();
      commit('SET_CATEGORIES', data);
    } catch (error) {
      // ignore
    } finally {
      commit('SET_UI_FLAG', { fetching: false });
    }
  },
  async create({ commit }, categoryData) {
    commit('SET_UI_FLAG', { creating: true });
    try {
      const { data } = await citizenComplaintCategoriesAPI.create(categoryData);
      commit('ADD_CATEGORY', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { creating: false });
    }
  },
  async update({ commit }, { id, ...categoryData }) {
    commit('SET_UI_FLAG', { updating: true });
    try {
      const { data } = await citizenComplaintCategoriesAPI.update(
        id,
        categoryData
      );
      commit('UPDATE_CATEGORY', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { updating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { deleting: true });
    try {
      await citizenComplaintCategoriesAPI.delete(id);
      commit('DELETE_CATEGORY', id);
    } finally {
      commit('SET_UI_FLAG', { deleting: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
